import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useEffectAsync } from "../../../common/hooks/use-effect-async";
import { Dialog, ThemeProvider } from "@mui/material";
import { GetWhoAmIResponse } from "../../query/get-who-am-i/get-who-ami-i-response";
import { GetWhoAmIHandler } from "../../query/get-who-am-i/get-who-am-i-handler";
import { SupplierContactDataForm } from "./supplier-contact-data-form";
import { SupplierContactDataReportSuccess } from "./supplier-contact-data-report-success";
import { SupplierContactDataConfirmationSuccess } from "./supplier-contact-data-confirmation-success";
import { useTimeout } from "../../../common/hooks/use-timeout";
import { notificationModel } from "../../../common/component/notifications/notification-model";
import { t } from "i18next";

import "./style.scss";
import { VPUITheme } from "../../../common/theme/vpui-theme";

export const SupplierContactDataValidationPopup  =
    ({ isVoluntary, onClose }:
     { isVoluntary?: boolean, onClose?: () => void },
    ) => {
    const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
    const [isUserDataValidated, setIsUserDataValidated] = useState<boolean | undefined>(undefined);
    const [supplierData, setSupplierData] = useState<GetWhoAmIResponse | undefined>(undefined);

    const [incorrectDataReportTicketNumber, setIncorrectDataReportTicketNumber] = useState<string | undefined>();

    useEffectAsync(async () => {
        setSupplierData(await GetWhoAmIHandler());
    }, []);

    useEffect(() => {
        if (supplierData && (supplierData.userDataValidatedAt === undefined || isVoluntary)) {
            setIsUserDataValidated(false);
            setIsPopupOpen(true);
        }
    }, [supplierData]);

    const handleContactDataValidated = useCallback(() => setIsUserDataValidated(true), []);
    const handleReportCreated = useCallback((ticketNumber: string) => {
        setIncorrectDataReportTicketNumber(ticketNumber);
    }, []);

    useTimeout(() => {
        notificationModel.addSuccessMessage(t("components.supplierValidationPopup.success"));
        setIsPopupOpen(false);
    }, 2500, !!isUserDataValidated);

    useTimeout(() => {
        notificationModel.addSuccessMessage(t("components.supplierValidationPopup.reportCreatedNotification", {
            ticketNumber: incorrectDataReportTicketNumber,
        }));
        setIsPopupOpen(false);
    }, 2500, incorrectDataReportTicketNumber !== undefined);

    return isPopupOpen ?
        <ThemeProvider theme={VPUITheme}>
            <Dialog open={true} fullWidth={true}>
                {isUserDataValidated ?
                    <SupplierContactDataConfirmationSuccess /> :
                    !incorrectDataReportTicketNumber ?
                        <SupplierContactDataForm isVoluntary={isVoluntary ?? false} supplierData={supplierData!}
                                                 onValidated={handleContactDataValidated}
                                                 onReportCreated={handleReportCreated}
                                                 onClose={onClose} /> :
                        <SupplierContactDataReportSuccess ticketNumber={incorrectDataReportTicketNumber} />}
            </Dialog>
        </ThemeProvider> :
        <Fragment />;
};
